export default "__VITE_ASSET__pcpLvvty__"